import React, { useEffect, useRef } from "react";
import { findDOMNode } from "react-dom";
// import * as R from "ramda";
import Sessions from "Portal/NewPortal/Sections/Home/Cards/Sessions";
import Profile from "Portal/NewPortal/Sections/Home/Cards/Profile";
import Tasks from "Portal/NewPortal/Sections/Home/Cards/Tasks/View";
import Resources from "Portal/NewPortal/Sections/Home/Cards/Resources";
import Files from "Portal/NewPortal/Sections/Home/Cards/Files";
import Applications from "Portal/NewPortal/Sections/Home/Cards/Applications";
// import Calendar from "Portal/NewPortal/Sections/Home/Cards/Calendar/View";
import { Div } from "components/Base";
import { noop, isEmptyOrNil } from "utils/General";
import CSSModules from "react-css-modules";
import css from "../styles.scss";
import * as R from "ramda";
import { connect } from "react-redux";
import { actions, getters } from "../../PortalHome/model";
import { Default, Mobile } from "Portal/NewPortal/Shared/MediasQuery";
import {
  getHasResources,
  getHasFiles,
  getHasSessions,
  getShouldShowSessions,
  getHasApplications
} from "Portal/NewPortal/PortalHome/selectors";
const decorate = R.compose(
  connect(
    state => ({
      shouldScrollToSection: getters.shouldScrollToSection(state),
      hasResources: getHasResources(state),
      hasFiles: getHasFiles(state),
      hasSessions: getHasSessions(state),
      shouldShowSessions: getShouldShowSessions(state),
      hasApplications: getHasApplications(state)
    }),
    {
      setShouldScrollToSection: actions.setShouldScrollToSection,
      setActiveWikiPage: actions.setActiveWikiPage
    }
  )
);

const setHeightToCards = ({ leftCard, rightCard }) => {
  const containerRight = leftCard.childNodes[1];
  const containerLeft = rightCard.childNodes[1];

  const heightRight = containerRight ? containerRight.offsetHeight : 0;
  const heightLeft = containerLeft ? containerLeft.offsetHeight : 0;

  if (heightRight > heightLeft) {
    containerLeft.style.height = `${heightRight}px`;
  } else {
    containerRight.style.height = `${heightLeft}px`;
  }
};

const Home = ({
  shouldScrollToSection = false,
  setShouldScrollToSection = noop,
  setActiveWikiPage = noop,
  hasResources,
  hasFiles,
  hasSessions,
  shouldShowSessions
}) => {
  const resourcesCardRef = useRef(null);
  const tasksCardRef = useRef(null);
  const applicationsCardRef = useRef(null);
  const filesCardRef = useRef(null);

  const sessionCardRef = useRef(null);
  const profileCardRef = useRef(null);

  useEffect(() => {
    if (shouldScrollToSection) {
      /**
       * Scrolls to Resources card (minus 60px for the header)
       * @type {Element | Text}
       */

      const cardRefString = `${shouldScrollToSection}CardRef`;

      const cardRef = R.prop(cardRefString, {
        resourcesCardRef,
        tasksCardRef,
        filesCardRef
      });

      const cardElement = findDOMNode(cardRef.current);
      if (cardElement) {
        cardElement.scrollIntoView({
          block: "start",
          inline: "nearest",
          behavior: "smooth"
        });
        window.scrollTo({
          top: cardElement.offsetTop - 60,
          behavior: "smooth"
        });
        setShouldScrollToSection(false);
        setActiveWikiPage(null);
      }
    }
  }, [shouldScrollToSection]);
  const gapStyle = { gap: "32px" }; // Objeto para el estilo de gap

  useEffect(() => {
    if (resourcesCardRef?.current && filesCardRef?.current) {
      const resourcesCard = findDOMNode(resourcesCardRef.current);
      const filesCard = findDOMNode(filesCardRef.current);

      if (!isEmptyOrNil(resourcesCard) && !isEmptyOrNil(filesCard)) {
        setHeightToCards({
          leftCard: resourcesCard,
          rightCard: filesCard
        });
      }
    }
  }, [resourcesCardRef, filesCardRef, hasResources, hasFiles]);

  useEffect(() => {
    if (sessionCardRef?.current && profileCardRef?.current) {
      const sessionCard = findDOMNode(sessionCardRef.current);
      const profileCard = findDOMNode(profileCardRef.current);

      if (!isEmptyOrNil(sessionCard) && !isEmptyOrNil(profileCard)) {
        setHeightToCards({
          leftCard: sessionCard,
          rightCard: profileCard
        });
      }
    }
  }, [sessionCardRef, profileCardRef]);

  return (
    <Div my={8} display="column.center" width={1}>
      {/* Desktop */}
      <Default>
        <Div display="column" style={gapStyle}>
          <Div display="row.center" style={gapStyle} width={1}>
            {shouldShowSessions && hasSessions ? (
              <Div className={css.column}>
                <Sessions ref={sessionCardRef} />
              </Div>
            ) : null}
            <Div
              className={css.column}
              style={!hasSessions ? { width: "100%" } : {}}
            >
              <Profile ref={profileCardRef} />
            </Div>
          </Div>

          <Div display="row.center" width={1}>
            <Applications ref={applicationsCardRef} />
          </Div>

          <Div display="row.center" width={1}>
            <Tasks ref={tasksCardRef} />
          </Div>

          <Div display="row.center" style={gapStyle} width={1}>
            {hasResources ? (
              <Div
                className={css.column}
                style={!hasFiles ? { width: "100%" } : {}}
              >
                <Resources ref={resourcesCardRef} />
              </Div>
            ) : null}

            {hasFiles ? (
              <Div
                className={css.column}
                style={!hasResources ? { width: "100%" } : {}}
              >
                <Files ref={filesCardRef} />
              </Div>
            ) : null}
          </Div>

          <Div display="row.flex-start.flex-start" style={gapStyle} width={1}>
            {/*<Div className={css.column}>
              <Calendar />
            </Div>*/}

            {/*
            <Div className={css.column}>
              <></>
            </Div>
            */}
          </Div>
        </Div>
      </Default>

      {/* Mobile */}
      <Mobile>
        <Div display="column" style={gapStyle}>
          <Div display="column.center" style={gapStyle} width={1}>
            {hasSessions ? (
              <Div className={css.row}>
                <Sessions ref={sessionCardRef} />
              </Div>
            ) : null}
            <Div className={css.row}>
              <Profile ref={profileCardRef} />
            </Div>
          </Div>
          <Div display="column.center" width={1}>
            <Applications ref={applicationsCardRef} />
          </Div>

          <Div display="column.center" width={1}>
            <Tasks ref={tasksCardRef} />
          </Div>

          <Div display="column.center" style={gapStyle} width={1}>
            {hasResources ? (
              <Div className={css.row}>
                <Resources ref={resourcesCardRef} />
              </Div>
            ) : null}

            {hasFiles ? (
              <Div className={css.row}>
                <Files ref={filesCardRef} />
              </Div>
            ) : null}
          </Div>

          <Div display="column.center" style={gapStyle} width={1}>
            {/*
            <Div className={css.row}>
              <Calendar />
            </Div>
            <Div className={css.row}>
              <></>
            </Div>
            */}
          </Div>
        </Div>
      </Mobile>
    </Div>
  );
};

export default decorate(CSSModules(Home, css));
